import { axios } from "./axios";
import { GET, POST } from "./endPoints";

export const loginUser = async (data) => {
  try {
    let response = await axios.post(POST.LOGIN, data);
    console.log("Login response:", response);
    return response;
  } catch (err) {
    throw err;
  }
};

export const logoutUser = async (token) => {
  try {
    // Pass the token in the Authorization header
    const response = await axios.post(
      POST.LOGOUT,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Logout response:", response);

    return response;
  } catch (err) {
    throw err;
  }
};

export const addClient = async (clientData) => {
  try {
    const token = localStorage.getItem("authToken"); // Retrieve token
    const response = await axios.post(POST.ADD_CLIENT, clientData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err) {
    throw err;
  }
};


export const fetchClients = async (page = 1, limit = 10) => {
  try {
    const token = localStorage.getItem("authToken"); // Retrieve token
    const response = await axios.get(`${GET.CLIENT_LIST}?page=${page}&limit=${limit}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Assuming the API returns data in response.data
  } catch (err) {
    throw err;
  }
};


export const createOrder = async (createOrder) => {
  try {
    const token = localStorage.getItem("authToken"); // Retrieve token
   
    const response = await axios.post(POST.CREATE_ORDER, createOrder, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err) {
    throw err;
  }
};


export const fetchDashboardCount = async () => {
  try {
    const token = localStorage.getItem("authToken"); // Retrieve token

    console.log("token", token);
    const response = await axios.get(`${GET.DASHBOARD_COUNT}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Dashboard count response:", response.data);
    return response.data; // Assuming the API returns data in response.data
  } catch (err) {
    throw err;
  }
};


export const getUserDetail = async () => {
  try {
    const token = localStorage.getItem("authToken"); // Retrieve token

    console.log("token", token);
    const response = await axios.get(`${GET.USER_DETAILS}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Dashboard count response:", response.data);
    return response.data; // Assuming the API returns data in response.data
  } catch (err) {
    throw err;
  }
};

export const fetchOrders = async (page = 1, limit = 10) => {
  try {
    const token = localStorage.getItem("authToken"); // Retrieve token
    const response = await axios.get(`${GET.ORDER_LIST}?page=${page}&limit=${limit}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Assuming the API returns data in response.data
  } catch (err) {
    throw err;
  }
};

export const updateOrder = async (updateOrder) => {
  try {
    const token = localStorage.getItem("authToken"); // Retrieve token

    const response = await axios.post(
      POST.UPDATE_ORDER, 
      updateOrder,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};


export const orderStatus = async (orderStatus) => {
  try {
    const token = localStorage.getItem("authToken"); // Retrieve token

    const response = await axios.post(
      POST.UPDATE_ORDER_STATUS, 
      orderStatus,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};


export const deleteStatus = async (deleteStatus) => {
  try {
    const token = localStorage.getItem("authToken"); // Retrieve token


    console.log("deleteStatus", deleteStatus);
    const response = await axios.post(
      POST.DELETE_ORDER, 
      deleteStatus,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const uploadFile = async (formData) => {
  try {
    const token = localStorage.getItem("authToken"); // Retrieve token
    
    const response = await axios.post(POST.UPLOAD_FILE, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (err) {
    throw err;
  }
};
